<template>
  <v-footer class="pa-3 fixed-bottom" fixed>
    <v-spacer></v-spacer>
    <div>{{ $globalConfig.APP_NAME === 'senso' ? 'Senso Learn' : 'Improve' }} &copy; {{ new Date().getFullYear() }}</div>
    <a class="pl-3" :href="privacyPolicyUrl" target="_blank" rel="noopener" style="color: rgba(0, 0, 0, 0.87) !important;">Privacy Policy</a>
  </v-footer>
</template>

<script>
import { websiteUrl } from "@/config.js";

export default {
  data() {
    return { privacyPolicyUrl: websiteUrl("/privacy-policy") };
  }
};
</script>
